module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic_1.8b62178f.woff";